import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Section from '../../section';
import Container from '../../container';
import StatGrid from '../../stat-grid';
import Waves from '../../waves';
import ProgramDonate from '../program-donate';

const ProgramProgress = ({ stats, id, showDonation }) => {
  const isTumi = `${id}` === process.env.TUMI_PROGRAM;

  return (
    <ProgramProgressSection dark>
      <Container>

        <Headline>Stats and Progress</Headline>
        <StatGrid stats={stats} isTumi={isTumi} />

        {showDonation &&
          <Fragment>
            <Headline>
              Make a Contribution
              {isTumi && <span>& Get A Chance To Win a Unique Tumi Art Piece</span>}
            </Headline>
            <ProgramDonate
              id={id}
              isDockers={`${id}` === process.env.DOCKERS_PROGRAM}
              isTumi={isTumi}
              buttonIsDark
            />
          </Fragment>
        }

      </Container>
      <Waves position="bottom" alignment="bottom" height={154} color="#fff" inverted />
    </ProgramProgressSection>
  );
};

const ProgramProgressSection = styled(Section)`
  position: relative;
  text-align: center;
`;

const Headline = styled.h4`
  margin-bottom: 60px;
  color: #fff;

  &:last-of-type {
    margin-top: 92px;
  }

  span {
    display: block;
  }
`;

ProgramProgress.propTypes = {
  stats: PropTypes.array,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showDonation: PropTypes.bool,
};

export default ProgramProgress;
